// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-l"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 5V18C8 18.5523 8.44772 19 9 19H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersLIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-l',
    ref,
    icon: element,
  },
));

LettersLIcon.displayName = 'LettersLIcon';

export default LettersLIcon;
